import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';
import { RRLayoutsModel } from '../../models/layouts.model';

@Component({
  selector: 'rr-list-builder',
  templateUrl: './list-builder.component.html',
  styleUrls: ['./list-builder.component.scss'],
})
export class ListBuilderComponent {
  @Input() autoColClass: boolean = false;
  @Input() layout: RRLayoutsModel[];
  @Output() actionClicked: EventEmitter<any> = new EventEmitter();

  constructor() {}

  public emitEvent(event: any): void {
    this.actionClicked.emit(event);
  }
  public getTooltipPosition(col: RRLayoutsModel): AvailableBSPositions {
    return col.link?.tooltipPosition ? col.link?.tooltipPosition : 'auto';
  }

  public getColClass(col: RRLayoutsModel): string {
    if (!col) {
      return;
    }
    let returnString: string = '';
    if (col.class) {
      returnString = col.class;
    }
    if (this.autoColClass && this.layout?.length) {
      if (this.layout.length !== 5 && this.layout.length <= 6) {
        returnString += ' col-md-' + (12 / this.layout.length).toString();
      } else if (this.layout.length === 5) {
        returnString += ' col-md-20';
      }
    }
    return returnString;
  }
}
